import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';

export const businessOnboardingNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> =
  new Map([
    [
      ButtonActionType.SAVE_PRIMARY_DIRECTOR_INFO,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      },
    ],
  ]);
